/**
 * Fills props that are undefined from `defaults`, like React's `defaultProps`.
 * React 19 (which the App Router renders with) no longer applies `defaultProps`
 * to function components; the components keep the static `defaultProps` for
 * React 18 and for their prop types, and call this so both behave the same.
 */
export function withDefaultProps<P extends object>(props: P, defaults: object): P {
  const out = { ...props } as Record<string, unknown>
  for (const [key, value] of Object.entries(defaults)) {
    if (out[key] === undefined) out[key] = value
  }
  return out as P
}
